export default __webpack_public_path__ + "static/media/shrutiBlow.2245e1bc.wav";